import { combineReducers } from 'redux';
import gallery from './reducers';

export default combineReducers({
  gallery,
});
